const FIREBASE_ERROR_CODES = {
  "auth/invalid-login-credentials": "Wrong credentials",
  "auth/email-already-in-use": "Email already exists",
  "auth/too-many-requests": "Too many requests",
  "auth/popup-closed-by-user": "Popup closed by user",
};
export const firebaseErrorParser = (code) => {
  return FIREBASE_ERROR_CODES[code] || "Something went wrong!";
};
